import { render, staticRenderFns } from "./UsernameInput.vue?vue&type=template&id=5325d457&scoped=true&"
import script from "./UsernameInput.vue?vue&type=script&lang=js&"
export * from "./UsernameInput.vue?vue&type=script&lang=js&"
import style0 from "./UsernameInput.vue?vue&type=style&index=0&id=5325d457&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5325d457",
  null
  
)

export default component.exports